import { useSearchParams } from "react-router-dom"
import { useContext, useState } from "react"
import BaseHeadBanner from "../../../components/elements/BaseHeadBanner"
import BasePage from "../../../components/layout/BasePage"
import BaseInputField from "../../../components/elements/BaseInputField"
import BaseGrowBody from "../../../components/elements/BaseGrowBody"
import { Form } from "antd"
import BaseButton from "../../../components/elements/BaseButton"
import BaseInputArea from "../../../components/elements/BaseInputArea"
import { Camera, Plus, X } from "lucide-react"
import AddImagesModal from "../components/AddImagesModal"
import { ModalContext } from "../../../components/contexts/ModalContext"
import { useSaveReportMutation } from "../api/services"
import { useQueryClient } from "@tanstack/react-query"

type Material = {
    name: string
    totalPrice: number
}

export default function AddReport() {
    const [searchParams] = useSearchParams()
    const [documents, setDocuments] = useState<File[]>([])
    const modalCon = useContext(ModalContext)
    const queryClient = useQueryClient()

    console.log(searchParams.get("session"))
    console.log(searchParams.get("sessionQueryKey"))
    console.log(searchParams.get("object"))

    const [form] = Form.useForm()

    const { mutate: saveReport } = useSaveReportMutation(queryClient, searchParams.get("sessionQueryKey") ?? "")

    const handleSaveReport = () => {
        const formData = new FormData()

        // Add form data
        formData.append("date", new Date().toISOString())
        formData.append("sessionId", searchParams.get("session") || "")
        formData.append("objectId", searchParams.get("object") || "")
        formData.append("information", form.getFieldValue("information") as string)

        // Add materials as JSON string
        const materials = (form.getFieldValue("materials") as Material[]) || []
        formData.append("materials", JSON.stringify(materials))

        // Add documents
        documents.forEach((document) => {
            formData.append("documents", document)
        })

        console.log("FormData to be sent:", formData)
        saveReport(formData)
    }

    return (
        <BasePage>
            <BaseHeadBanner title="Bericht erstellen" />
            <Form form={form} onFinish={handleSaveReport}>
                <BaseGrowBody classProps="flex flex-col pt-4">
                    <Form.Item name="information" className="w-full !mb-2" rules={[{ required: true, message: "Informationen sind erforderlich" }]}>
                        <BaseInputArea minRows={10} label="Informationen - Was wurde gemacht?" onChange={() => {}} />
                    </Form.Item>

                    {/* Materials Section */}

                    <Form.List name="materials">
                        {(fields, { add, remove }) => (
                            <div className="">
                                {fields.map(({ key, name, ...restField }) => (
                                    <div key={key} className={`flex gap-2 items-start pr-8 relative mb-2`}>
                                        <Form.Item {...restField} name={[name, "materialName"]} className="flex-1 !mb-0" rules={[{ required: true, message: "Material erforderlich" }]}>
                                            <BaseInputField label="Material" onChange={() => {}} placeholder="z.B. Schrauben, Farbe, etc." type="text" />
                                        </Form.Item>
                                        <Form.Item {...restField} name={[name, "totalPrice"]} className="w-32 !mb-0" rules={[{ required: true, message: "Preis erforderlich" }]}>
                                            <BaseInputField label="Gesamtpreis (€)" type="number" onChange={() => {}} placeholder="0.00" />
                                        </Form.Item>
                                        <X className="absolute bottom-3.5 right-0" onClick={() => remove(name)} />
                                    </div>
                                ))}
                                <button type="button" onClick={() => add()} className="w-full btn btn-outline mt-8">
                                    <Plus />
                                    Material hinzufügen
                                </button>
                            </div>
                        )}
                    </Form.List>

                    <button
                        type="button"
                        className="btn btn-outline w-full mt-2 mb-4"
                        onClick={(e) => {
                            e.preventDefault()
                            modalCon?.trigger(0)
                        }}>
                        <Camera />
                        Bilder hochladen {documents.length > 0 && `(${documents.length})`}
                    </button>
                    <div className="flex flex-row gap-2 w-full">
                        <BaseButton type="button" label="Abbrechen" func={() => {}} icon={<></>} classProps="grow" />
                        <BaseButton type="submit" label="Speichern" func={() => {}} icon={<></>} classProps="grow btn !btn-primary" />
                    </div>
                </BaseGrowBody>
            </Form>
            <AddImagesModal modalId={0} queryKeyOfSession={searchParams.get("sessionQueryKey") ?? ""} onDocumentsChange={setDocuments} />
        </BasePage>
    )
}
